import cn from 'classnames';
import React, { useEffect } from 'react';
import { ErrorBoundary } from '@sentry/react';
import { Button } from '@react-md/button';
import { TextIconSpacing } from '@react-md/icon';
import { Alert, AlertHeading } from '@components/alert';
import { Icons } from '@components/icons';
import { usePrevious } from '@hooks';

import styles from './viewer-window.module.scss';

const ViewerReset = ({ modelId, resetError }: { modelId?: number; resetError(): void }) => {
    const prevModelId = usePrevious(modelId);

    useEffect(() => {
        if (modelId !== prevModelId) {
            resetError();
        }
    }, [modelId, prevModelId, resetError]);

    return null;
};

export const ViewerErrorBoundary: React.FC<{
    modelId?: number;
}> = ({ modelId, children }) => {
    return (
        <ErrorBoundary
            fallback={({ resetError }) => (
                <div className={cn(styles.box, styles.error)}>
                    <div className={styles.inner}>
                        <ViewerReset modelId={modelId} resetError={resetError} />

                        <Alert show type="error" variant="outlined" className={cn('justify-center', 'h-full')}>
                            {/*<AlertHeading iconType="error">*/}
                            {/*    <span>*/}
                            {/*        <span>"Something busted that we didn't anticipate."</span>*/}
                            {/*        <Button*/}
                            {/*            buttonType="icon"*/}
                            {/*            theme="primary"*/}
                            {/*            className="rmd-button--icon-flat"*/}
                            {/*            onClick={resetErrorBoundary}*/}
                            {/*            aria-label="Refresh"*/}
                            {/*            disableRipple*/}
                            {/*        >*/}
                            {/*            <Icons.Rotate width={18} height={18} />*/}
                            {/*        </Button>*/}
                            {/*    </span>*/}
                            {/*</AlertHeading>*/}

                            <Button
                                theme="primary"
                                className={cn('rmd-button--flat', 'fade-in')}
                                onClick={resetError}
                                disableRipple
                            >
                                <TextIconSpacing icon={<Icons.Rotate width={16} height={16} />} forceIconWrap>
                                    Viewer setup failed
                                </TextIconSpacing>
                            </Button>

                            {/*<Button*/}
                            {/*    theme="primary"*/}
                            {/*    themeType="contained"*/}
                            {/*    // className={cn('rmd-button--flat', 'fade-in')}*/}
                            {/*    onClick={resetErrorBoundary}*/}
                            {/*    disableRipple*/}
                            {/*>*/}
                            {/*    Refresh*/}
                            {/*</Button>*/}
                        </Alert>
                    </div>
                </div>
            )}
        >
            {children}
        </ErrorBoundary>
    );
};
